interface WaveDividerProps {
  topColor?: string;
  bottomColor?: string;
  flip?: boolean;
  className?: string;
}

const WaveDivider = ({
  topColor = "hsl(var(--background))",
  bottomColor = "hsl(var(--muted))",
  flip = false,
  className = "",
}: WaveDividerProps) => {
  return (
    <div
      className={`relative w-full overflow-hidden leading-[0] ${flip ? "rotate-180" : ""} ${className}`}
      aria-hidden="true"
      style={{ marginTop: "-1px", marginBottom: "-1px" }}
    >
      <svg
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
        className="w-full h-[60px] md:h-[80px] lg:h-[100px] block"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background fill for bottom section */}
        <rect width="1440" height="120" fill={bottomColor} />
        {/* Wavy shape filled with top section color */}
        <path
          d="M0,0 L0,60 C120,100 240,110 360,80 C480,50 600,20 720,40 C840,60 960,100 1080,90 C1200,80 1320,40 1440,60 L1440,0 Z"
          fill={topColor}
        />
      </svg>
    </div>
  );
};

export default WaveDivider;
